$('.js-close-banner').on('click', function() {
  const $this = $(this);
  $this.closest('.header-banner').slideUp();
})
